import store from "../../store/index";
export function getBase() {
  return "http://admin.fasteasy.in/";
}
export const MPLAN_KEY = "0c110205f832fca72a4392ce46aedf59";
export const MPLAN_BASE =
  "http://submplan.fasteasy.in/MPLAN/Services/API.asmx/";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bonrixmobile.fasteasytechno1";
export function addAuthParams(params) {
  let user = store.getters.user;
  Object.keys(user).forEach((key) => {
    if (key !== "UserName" && key !== "Email") {
      params[key] = user[key];
    }
  });
  return params;
}
export function getURL(url) {
  if (url && url.startsWith("/Admin/")) return `${getBase()}${url}`;
  return `${getBase()}Admin${url}`;
}
export function getProviders(items) {
  return items.map((item) => {
    let { Service, Circle_Image } = item;
    item.name = Service;
    item.value = Service;
    item.src = `${getBase()}${Circle_Image}`;
    return item;
  });
}
export const RECHARGE_TYPE = {
  RR: "Prepaid",
  PP: "Postpaid",
  DTH: "DTH",
  STV: "STV",
  BP: "Gas",
};
export const PROVIDERS = {
  prepaid: {
    Service_Type: "RR",
    SubType: "*",
  },
  postpaid: {
    Service_Type: "PP",
    SubType: "*",
  },
  dth: {
    Service_Type: "dth",
    SubType: "*",
  },
  stv: {
    Service_Type: "STV",
    SubType: "*",
  },
  broadband: {
    Service_Type: "bp",
    SubType: "bb",
  },
  electricity: {
    Service_Type: "bp",
    SubType: "eb",
  },
  gas: {
    Service_Type: "bp",
    SubType: "gb",
  },
  water: {
    Service_Type: "bp",
    SubType: "wb",
  },
};
export function printReceipt(item) {
  let { html } = require("../html/success");
  if (item.refund_status.toLowerCase() == "success") {
    html = require("../html/refund").html;
  }
  item.total = item.total_amount;
  let { UserName, MobileNo } = store.getters.user;
  html = html.replace("UserName", UserName);
  html = html.replace("MobileNo", MobileNo);
  html = html.replace("_logo", require("../../assets/images/print_logo.jpeg"));
  Object.keys(item).forEach((key) => {
    if (key !== "status" && key != "transid") {
      html = html.split(`_${key}`).join(item[key]);
    }
  });
  let win = window.open("about:blank", "_blank");
  win.document.write(html);
  win.document.close();
  win.print();
}
